import { render, staticRenderFns } from "./monthlyDetail.vue?vue&type=template&id=5b5a73b7&scoped=true&"
import script from "./monthlyDetail.vue?vue&type=script&lang=js&"
export * from "./monthlyDetail.vue?vue&type=script&lang=js&"
import style0 from "./monthlyDetail.vue?vue&type=style&index=0&id=5b5a73b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5a73b7",
  null
  
)

export default component.exports